import { Box, Divider, Grid, Skeleton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "../../../../../helpers/methods";
import rahuTransitsStyles from "../RahuTransits.styles";

interface CustomProps {
  meanNakshatra: any;
  trueNakshatra: any;
  isLoading: boolean;
}

const Nakshatra = (props: CustomProps) => {
  const classes = rahuTransitsStyles;
  const { t, i18n } = useTranslation();

  const getMeanRahu = () => {
    return (
      <Stack direction={"column"} alignItems={"center"} spacing={2}>
        {props.meanNakshatra.map((item: any) => {
          return (
            <Box sx={classes.transitBox}>
              {props.isLoading ? (
                <>
                  <Skeleton
                    variant="text"
                    width="80%"
                    height={50}
                    sx={{ m: 1 }}
                  />
                  <Skeleton
                    variant="text"
                    width="60%"
                    height={50}
                    sx={{ m: 1 }}
                  />
                </>
              ) : (
                <>
                  <Typography my={1} mx={1} sx={classes.contentText}>
                    From <b>{item.from_nakshatra}</b> to{" "}
                    <b>{item.to_nakshatra}</b>{" "}
                  </Typography>
                  <Typography mb={1} mx={1} sx={classes.contentText}>
                    {formatDateTime(item.datetime, i18n.language)}
                  </Typography>
                </>
              )}
            </Box>
          );
        })}
      </Stack>
    );
  };

  const getTrueRahu = () => {
    return (
      <Stack direction={"column"} alignItems={"center"} spacing={2}>
        {props.trueNakshatra.map((item: any) => {
          return (
            <Box sx={classes.transitBox}>
              {props.isLoading ? (
                <>
                  <Skeleton
                    variant="text"
                    width="80%"
                    height={50}
                    sx={{ m: 1 }}
                  />
                  <Skeleton
                    variant="text"
                    width="60%"
                    height={50}
                    sx={{ m: 1 }}
                  />
                </>
              ) : (
                <>
                  <Typography my={1} mx={1} sx={classes.contentText}>
                    From <b>{item.from_nakshatra}</b> to{" "}
                    <b>{item.to_nakshatra}</b>{" "}
                  </Typography>
                  <Typography mb={1} mx={1} sx={classes.contentText}>
                    {formatDateTime(item.datetime, i18n.language)}
                  </Typography>
                </>
              )}
            </Box>
          );
        })}
      </Stack>
    );
  };

  const getNakshatra = () => {
    return (
      <Grid container>
        <Grid item xl={6} lg={6} md={12} sm={12} xs={12} p={1}>
          <Stack direction={"column"} alignItems={"center"} spacing={2} pb={1}>
            <Typography sx={classes.transitHeader} px={2}>
              {t("rahuTransit")}
            </Typography>
            <Divider
              sx={{
                border: "1px solid rgba(255, 255, 255, 0.21)",
                width: "50%",
                height: "0px",
                mt: "2px !important",
                mb: "8px !important",
              }}
            />
          </Stack>
          {getMeanRahu()}
        </Grid>
        <Grid item xl={6} lg={6} md={12} sm={12} xs={12} p={1}>
          <Stack direction={"column"} alignItems={"center"} spacing={2} pb={1}>
            <Typography sx={classes.transitHeader} px={2}>
              {t("trueRahuTransit")}
            </Typography>
            <Divider
              sx={{
                border: "1px solid rgba(255, 255, 255, 0.21)",
                width: "50%",
                height: "0px",
                mt: "2px !important",
                mb: "8px !important",
              }}
            />
          </Stack>
          {getTrueRahu()}
        </Grid>
      </Grid>
    );
  };

  return getNakshatra();
};

export default Nakshatra;
